<template>
    <b-modal
            @hidden="modalHasBeenHidden"
            id="ModalEditOrder"
            ref="ModalEditOrder"
            @shown="initEditOrder"
            size="lg"
            centered
    >
        <div slot="modal-title">
            <h4 class="modal-title" v-if="order">Изменить заказ № {{order.id}}</h4>
            <h4 class="modal-title" v-else>Новый заказ</h4>
        </div>
        <loading v-if="loading" :size="3" message="Сохраняем..."></loading>
        <form v-else сlass="form-horizontal">
            <div class="row">
                <div class="form-group col-6 col-md-2" :class="{ 'has-danger': $v.newOrderData.orderDate.$error }">
                    <datepicker
                            v-model="newOrderData.orderDate"
                            format="dd/MM/yyyy"
                            lang="ru"
                            @input="$v.newOrderData.orderDate.$touch()"
                            :tabindex="1"
                    >
                    </datepicker>
                    <span class="small help-block text-danger" v-if="$v.newOrderData.orderDate.$error">Дата обязательна</span>
                </div>
                <div class="form-group col-6 col-md-2" :class="{ 'has-danger': $v.newOrderData.orderTime.$error }">
                    <select v-model="newOrderData.orderTime" class="form-control" @input="$v.newOrderData.orderTime.$touch()" tabindex="2">
                        <option v-for="item in timeOptions" :value="item">{{item}}</option>
                    </select>
                    <span class="small help-block text-danger" v-if="$v.newOrderData.orderTime.$error">Время обязательно</span>
                </div>
                <div class="form-group col-12 col-md-3">
                    <multiselect
                            :tabindex="3"
                            v-model="citySelected"
                            :options="cities"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="Город не выбран"
                            :allow-empty="false"
                            track-by="id" label="name"
                            @input="loadTechcenters"
                    >

                    </multiselect>
                </div>
                <div class="form-group col-12 col-md-5" :class="{ 'has-danger': $v.newOrderData.techcenterId.$error }">
                    <multiselect
                            :tabindex="4"
                            v-model="techcenterSelected"
                            :options="techcenters"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="true"
                            placeholder="Техцентр не выбран"
                            track-by="id" label="name"
                            @input="setTechcneter"
                            :loading="loadingTechcenters"
                            :value="null"
                    >

                    </multiselect>
                    <span class="small help-block text-danger" v-if="$v.newOrderData.techcenterId.$error">Обязательно укажите техцентр</span>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12" :class="{ 'has-danger': $v.newOrderData.description.$error }">
                    <textarea v-model="newOrderData.description" class="form-control" cols="30" rows="10"  @input="$v.newOrderData.description.$touch()" :tabindex="5"></textarea>
                    <span class="small help-block text-danger" v-if="$v.newOrderData.description.$error">Описание должно состоять как минимум из {{$v.newOrderData.description.$params.minLength.min}} символов</span>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-md-6" :class="{ 'has-danger': $v.newOrderData.clientPhone.$error }">
                    <div class="input-group">
                        <span class="input-group-addon">+7</span>
                        <input v-if="newOrderData.clientPhone !== '**********'"  v-mask="'(###) ###-##-##'"
                                v-model="newOrderData.clientPhone"
                                type="text"
                                class="input-mask-phone form-control"
                                :tabindex="6">
                        <input v-else
                               type="text"
                               class="form-control disabled"
                               disabled
                               value="(***) ***-**-**"
                        >
                    </div>
                </div>
                <div class="form-group col-12 col-md-6" :class="{ 'has-danger': $v.newOrderData.clientName.$error }">
                    <input v-model="newOrderData.clientName" type="text" class="form-control" placeholder="Имя клиента" :tabindex="7"/>
                </div>
            </div>
            <div class="row">
              <div class="form-group col-12 col-md-6 flex-md-first" :class="{ 'has-danger': $v.newOrderData.sum.$error }">
                <span>Первоначальная cумма заказ-наряда</span>
                <div class="input-group">
                  <input v-model="newOrderData.sum"
                         type="number"
                         class="input-mask-phone form-control text-right"
                         :tabindex="8">
                  <span class="input-group-addon"><i class="fa fa-rub"></i></span>
                </div>
              </div>
            </div>
        </form>
        <div slot="modal-footer">
            <div id="buttonAddOrEditOrder">
            <button v-if="!loading" :class="{ 'disabled': $v.newOrderData.$invalid }" :disabled="$v.newOrderData.$invalid" type="button" class="btn btn-success" @click.prevent="beforeUpdateForm" :tabindex="8" >
                <template v-if="order">Сохранить изменение</template>
                <template v-else>Добавить заказ</template>
            </button>
            </div>
            <b-tooltip v-if="$v.newOrderData.$invalid" target="buttonAddOrEditOrder" title="Обязательно заполните все поля"></b-tooltip>
        </div>
    </b-modal>
</template>
<script>
  import { required, minLength, minValue } from 'vuelidate/lib/validators'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import Multiselect from 'vue-multiselect'
  import moment from 'moment'
  import getTechcentersFromCityId from './../../gql/queries/getTechcenters.graphql'
  export default {
    computed: {
      cities () {
        return this.citiesOriginal.filter(function (item) {
          return item.enabled === true
        })
      },
      ...mapState({
        order: state => state.orderStore.editOrder,
        citiesOriginal: state => state.globalStore.cities
      })
    },
    data () {
      return {
        newOrderData: {},
        loading: false,
        timeOptions: [
          '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
          '14:00', '14:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30',
          '19:00', '19:30', '20:00', '20:30'
        ],
        techcenters: [],
        techcenterSelected: null,
        citySelected: null,
        loadingTechcenters: false
      }
    },
    methods: {
      /**
       * Валидация и выбор что делаем
       */
      beforeUpdateForm () {
        this.$v.newOrderData.$touch()
        if (this.$v.newOrderData.$error) {
          return
        }
        if (this.newOrderData.id) {
          this.updateOrder()
        } else {
          this.addOrder()
        }
      },
      /**
       * Добаление заказа
       */
      addOrder () {
        this.loading = true
        this.$store.dispatch('addOrder', this.newOrderData).then(() => {
          this.loading = false
          this.addToast({
            text: 'Заказ успешно добавлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.setClearNewOrder()
          this.$refs.ModalEditOrder.hide()
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при добавлении заказа:' + error,
            type: 'danger',
            dismissAfter: 3000
          })
        })
      },
      updateOrder () {
        this.loading = true
        this.$store.dispatch('updateOrder', this.newOrderData).then(() => {
          this.loading = false
          this.addToast({
            text: 'Заказ успешно обновлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.$refs.ModalEditOrder.hide()
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при обвнолении заказа:' + error,
            type: 'danger',
            dismissAfter: 3000
          })
        })
      },
      setClearNewOrder () {
        this.newOrderData = {
          id: null,
          orderDate: moment().format('DD/MM/YYYY').toString(),
          orderTime: '10:00',
          cityId: null,
          techcenterId: null,
          description: '',
          clientPhone: '',
          clientName: '',
          sum: 0
        }
        this.citySelected = this.cities[0]
        this.newOrderData.cityId = this.cities[0].id
        this.loadTechcenters(this.citySelected)
        this.$v.newOrderData.$reset()
      },
      modalHasBeenHidden () {
        if (this.order) {
          this.$store.commit('SET_EDIT_ORDER', null)
          this.setClearNewOrder()
        }
      },
      /**
       * Загрузка техцентров для выбранного города
       * @param city
       */
      loadTechcenters (city) {
        this.loadingTechcenters = true
        this.newOrderData.cityId = city.id
        this.techcenters = []
        this.newOrderData.techcenterId = null
        this.techcenterSelected = null
        this.$apollo.query({
          query: getTechcentersFromCityId,
          variables: {
            cityId: city.id,
            all: true,
            enabled: true
          }
        }).then(result => {
          this.techcenters = result.data.techcenters
          this.loadingTechcenters = false
          if (!this.order) {
            this.techcenterSelected = null
            this.newOrderData.techcenterId = null
          }
        }).catch(error => {
          console.log(error)
          this.loadingTechcenters = false
        })
      },
      /**
       * Установка техцентра
       * @param techcenter
       */
      setTechcneter (techcenter) {
        if (techcenter) {
          this.newOrderData.techcenterId = techcenter.id
        } else {
          this.newOrderData.techcenterId = null
        }
        this.$v.newOrderData.techcenterId.$touch()
      },
      initEditOrder () {
        if (this.order) {
          const editOrder = this.order
          this.citySelected = editOrder.techcenter.city
          this.loadTechcenters(this.citySelected)
          this.techcenterSelected = editOrder.techcenter
          this.newOrderData = {
            id: editOrder.id,
            orderDate: moment(editOrder.date, 'DD.MM.YYYY').format('DD/MM/YYYY').toString(),
            orderTime: editOrder.time,
            cityId: editOrder.techcenter.city.id,
            techcenterId: editOrder.techcenter.id,
            description: editOrder.description,
            clientPhone: editOrder.clientPhone,
            clientName: editOrder.clientName,
            sum: editOrder.sum
          }
        }
//        else {
//          /**
//           * Fix bug
//           * TODO remove after reliase bootstrab-vue package v 1 stable
//           * @see https://github.com/bootstrap-vue/bootstrap-vue/issues/1034
//           * @type {Element}
//           */
//          let dialog = document.getElementById('addEditOrderModal')
//          if (!dialog.classList.contains('show')) {
//            dialog.classList.add('show')
//          }
//        }
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    created () {
      this.setClearNewOrder()
    },
    components: {
      Multiselect
    },
    validations: {
      newOrderData: {
        orderDate: {
          required
        },
        orderTime: {
          required
        },
        techcenterId: {
          required
        },
        description: {
          required,
          minLength: minLength(6)
        },
        clientName: {
          required,
          minLength: minLength(2)
        },
        clientPhone: {
          required,
          minLength: minLength(15)
        },
        sum: {
          required,
          minValue: minValue(1)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalEditOrder.vue?3ad15ef6